import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import { lighten } from '@material-ui/core/styles/colorManipulator';
import { InputAdornment } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';

const toolbarStyles = (theme) => ({
	root: {
		paddingRight: theme.spacing.unit,
		backgroundColor: '#f8fafc',
		borderBottom: `1px solid ${theme.palette.grey[100]}`,
		padding: '24px 24px 20px',
		position: 'relative',
	},
	highlight:
		theme.palette.type === 'light'
			? {
					color: theme.palette.secondary.main,
					backgroundColor: lighten(
						theme.palette.secondary.light,
						0.85
					),
			  }
			: {
					color: theme.palette.text.primary,
					backgroundColor: theme.palette.secondary.dark,
			  },
	spacer: {
		flex: '1 1 100%',
	},
	actions: {
		color: theme.palette.text.secondary,
		display: 'flex',
		alignItems: 'center',
	},
	title: {
		flex: '0 0 auto',
		'& h6': {
			fontSize: '1.5rem',
			fontWeight: 600,
			color: theme.palette.text.primary,
			marginBottom: '4px',
		},
		'& .subtitle': {
			color: theme.palette.text.secondary,
			fontSize: '0.875rem',
			marginTop: '-2px',
		},
	},
	searchField: {
		marginLeft: theme.spacing.unit * 2,
		marginRight: theme.spacing.unit * 2,
		width: 300,
		'& .MuiOutlinedInput-root': {
			borderRadius: '8px',
			backgroundColor: '#ffffff',
			'& fieldset': {
				borderColor: theme.palette.grey[200],
			},
			'&:hover fieldset': {
				borderColor: theme.palette.grey[300],
			},
			'&.Mui-focused fieldset': {
				borderColor: theme.palette.primary.main,
			},
		},
		'& .MuiOutlinedInput-input': {
			padding: '12px 14px',
		},
	},
});

const EnhancedTableToolbar = (props) => {
	const { numSelected, classes, searchData } = props;

	return (
		<Toolbar
			className={classNames(classes.root, {
				[classes.highlight]: numSelected > 0,
			})}
		>
			<div className={classes.title}>
				{numSelected > 0 ? (
					<Typography color='inherit' variant='subtitle1'>
						{numSelected} selected
					</Typography>
				) : (
					<React.Fragment>
						<Typography variant='h6'>Locations Overview</Typography>
						<Typography className='subtitle'>
							Manage and track your Chekkit-enabled locations
						</Typography>
					</React.Fragment>
				)}
			</div>
			<div className={classes.spacer} />
			<div className={classes.actions}>
				<TextField
					className={classes.searchField}
					variant='outlined'
					placeholder='Search locations...'
					onChange={searchData}
					InputProps={{
						startAdornment: (
							<InputAdornment position='start'>
								<SearchIcon color='action' />
							</InputAdornment>
						),
					}}
				/>
			</div>
		</Toolbar>
	);
};

EnhancedTableToolbar.propTypes = {
	classes: PropTypes.shape({
		root: PropTypes.string,
		highlight: PropTypes.string,
		spacer: PropTypes.string,
		actions: PropTypes.string,
		title: PropTypes.string,
		searchField: PropTypes.string,
	}).isRequired,
	numSelected: PropTypes.number.isRequired,
	searchData: PropTypes.func.isRequired,
};

export default withStyles(toolbarStyles)(EnhancedTableToolbar);



// WEBPACK FOOTER //
// ./src/components/chekkit/EnhancedTableToolbar.js